export default __webpack_public_path__ + "static/media/lady_announce.ccd88d83.png";